module.exports = __webpack_public_path__ + "static/img/case-zg-page-bg-02.dde2e6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zg/case-zg-page-bg-02.jpg
// module id = qajp
// module chunks = 1